/* eslint-disable @typescript-eslint/no-explicit-any */
import { IResumen } from '../../../modules/sport/interfaces/profile';
import Image from '../../Image';
//import { IServiceCard } from '../../interfaces';

export default function ServicesCardProfile({
    service,
    i,
    scrollHandler,
}: {
    service: IResumen;
    i: number;
    scrollHandler: any;
}): JSX.Element {
    return (
        <>
            {' '}
            <div
                className="mx-auto md:mx-2 cursor-pointer sport-zoom bg-white flex flex-col justify-center items-center rounded-lg py-10 mb-10 md:mb-0 border-2 border-gray-200 shadow-profile"
                style={{ width: 205, height: 254 }}
                key={`ServicesCardProfile-${Math.random().toString(36).substr(2, 9)}-${i}`}
                onClick={() => scrollHandler(service.alt)}
            >
                <Image src={service.image} alt={service.alt} height={94} />
                <p
                    className={`text-center text-5xl font-bold pt-8  ${
                        service.total > 0 ? 'text-sm-integrate' : 'text-sm-blue-primary'
                    }`}
                >
                    {service.total}
                </p>
                <p className="text-center text-base italic font-bold pt-4 text-sm-blue-primary">
                    {service.title}
                    {service.type === 'integrar' && service.total > 1 ? 'es' : ''}
                </p>
            </div>
        </>
    );
}
